<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import Tab from './Tab.svelte'

  export let activeTab: string

  const tabs: array = [
    { code: 'bills', description: 'Каталог' },
    { code: 'makers', description: 'Мейкеры' },
  ]

  const dispatch = createEventDispatcher()

  function onClick(code) {
    dispatch('changeTab', code)
  }
</script>

<div class="header">
  <div class="logo-container">
    <img src="svg/marketplace-logo.svg" alt="marketplace-logo"/>
  </div>

  <div class="tabs-container desktop">
    {#each tabs as tab}
      <div class="tab-container">
        <Tab tab={tab} checked={tab.code === activeTab} on:click={() => onClick(tab.code)} />
      </div>
    {/each}
  </div>

  <div class="tabs-container mobile">
    <select bind:value={activeTab} on:change={() => onClick(activeTab)}>
      {#each tabs as tab}
        <option value="{tab.code}" selected="{tab.code === activeTab}">
          {tab.description}
        </option>
      {/each}
    </select>
  </div>

  <a href="https://capusta.space/self" class="button-container" target="_blank" rel="nofollow noopener">
    <button class="button plus">
      <span>Я тоже</span>
    </button>
  </a>
</div>

<style>
  select {
    background: transparent;
    border: none;
    outline: none;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 0;
  }

  .logo-container {
    max-width: 70px;
    font-size: 0;
  }

  .logo-container img {
    width: 100%;
  }

  .button-container {
    font-size: 0;
    text-decoration: none;
    outline: none;
    z-index: 100;
  }

  .tabs-container {
    display: flex;
    align-items: center;
    justify-content: stretch;
  }

  .tabs-container.desktop {
    display: none;
  }

  .tabs-container.mobile {
    display: block;
  }

  .tab-container:not(:last-child) {
    margin-right: 10px;
  }

  .button {
    width: 40px;
    height: 40px;
    display: inline-block;
    padding: 0;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    background: #212121;
    border-radius: 40px;
    text-decoration: none;
    border: none;
    outline: none;
    cursor: pointer;
  }

  .button span {
    display: none;
  }

  .button.plus {
    background-image: url('/svg/plus.svg');
    background-position: center;
    background-repeat: no-repeat;
  }

  @media screen and (min-width: 32rem) {

  }

  @media screen and (min-width: 481px) {
    .logo-container {
      max-width: none;
    }

    .tabs-container.desktop {
      display: flex;
    }

    .tabs-container.mobile {
      display: none;
    }

    .button {
      width: auto;
    }

    .button.plus {
      padding: 0px 20px 0px 40px;
      background-position: 20px center;
    }

    .button span {
      display: inline;
    }
  }
</style>
